import React, { Component } from 'react';
import { NONFINANCIALDATA } from '../../../constants';
class NonFinancialList extends Component {
    constructor() {
        super();
        this.state = {
            updatedNonFinancialData: []
        }
    }
    handleNonFinancialScoreChange = (event, id) => {
        this.props.financialDataCallback(NONFINANCIALDATA, event, id)
    }
    render() {
        if (this.props.data) {
            return (
                this.props.data.map(p => {
                    return (
                        < tr key={p.id} >
                            <td key={p.id + 'td'}>
                                {p.name}
                            </td>
                            <td key={p.id + 'td1'}>{p.currentScore}</td>
                            <td>
                                <select className="form-control" id="scoreSelect" onChange={(event) => this.handleNonFinancialScoreChange(event, p.id)}>
                                    <option value="">Select</option>
                                    {p.scores.map(element => {
                                        let tempValue;
                                        if (p.currentScore) {
                                            if ((p.currentScore).toString() === (element.value).toString()) {
                                                tempValue = element.value
                                                return (
                                                    <option key={p.id + Math.random()} selected={tempValue} value={p.currentScore}>{element.label} {'(' + element.value + ')'}</option>
                                                )
                                            } else {
                                                return (
                                                    <option key={p.id + Math.random()} value={element.value}>{element.label} {'(' + element.value + ')'}</option>
                                                )
                                            }
                                        } else {
                                            // tempValue = element.value
                                            return (
                                                <option key={p.id + Math.random()} value={element.value}>{element.label} {'(' + element.value + ')'}</option>
                                            )
                                        }

                                    })}
                                </select>
                            </td>
                            <td key={p.name + 'td2'}>
                                <span>{p.weight}</span>
                            </td>
                        </tr >
                    )
                })
            )
        }
    }
}

export default NonFinancialList;